import { styled, TextField } from '@mui/material';

/**
 * CleanTextField - A minimalist text field with subtle borders
 *
 * Provides consistent input styling with theme-aware colors.
 * Subtle focus states and hover effects.
 *
 * @see src/modules/TeamModule/components/TeamsV2Page.tsx
 */
export const CleanTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.spacing(2), // 8px
    background: theme.palette.background.paper,
    color: theme.palette.text.primary,
    '& input': {
      color: theme.palette.text.primary,
    },
    '& fieldset': {
      borderColor: theme.palette.divider,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.action.disabled,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 1,
    },
  },
}));
